

import {Component, Vue} from "vue-property-decorator"
import HomePageContentVice from "@/components/layout/HomePage/HomePageContentVice.vue";
import HomePageContentBrussel from "@/components/layout/HomePage/HomePageContentBrussel.vue";
import HomePageContentIBZ from "@/components/layout/HomePage/HomePageContentIBZ.vue";

@Component({
  components: {HomePageContentIBZ, HomePageContentBrussel, HomePageContentVice}
})
export default class Home extends Vue {
  name!: 'Home'

  pathToPics = require.context('../assets/', false, /\.[svjpn]{2}g$/);

  getPic(name: string): string {
    return this.pathToPics('./'.concat(name))
  }

}

